import React from 'react';
import styled from 'styled-components';
import { BodySmallText, FontEmphasis } from '@prisjakt/ui/text/variants';
import { useAppContext } from 'src/components/app-context';
import { layout } from 'src/components/base';
import { Price } from 'src/components/product-card-new/components/price';
import Rating from 'src/components/rating';
import { MiniCard } from '..';
import { Badge, BadgeSize } from '@prisjakt/ui/badge';

type RecentProductMiniCardProps = {
  id: number;
  title: string;
  image?: string | null;
  menu?: React.ReactNode;
  rating?: number | null;
  ratingCount?: number | null;
  price?: {
    regular?: number | null;
  };
  diffPercentage?: number | null;
  to: string;
  onClick?: () => void;
};

export const RatingWrapper = styled.div`
  margin-top: ${layout.measurements.spacing050};
`;

export const PriceWrapper = styled.div`
  margin-top: ${layout.measurements.spacing025};
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const DealBadge = styled(Badge)`
  margin-left: ${layout.measurements.spacing050};
`;

export const RecentProductMiniCard: React.FC<
  RecentProductMiniCardProps
> = props => {
  const { t } = useAppContext();

  return (
    <MiniCard
      title={props.title}
      image={props.image}
      menu={props.menu}
      to={props.to}
      onClick={props.onClick}
    >
      {props.rating && props.rating > 0 ? (
        <RatingWrapper>
          <Rating
            rate={props.rating}
            count={props.ratingCount}
            showCounterAs="number"
          />
        </RatingWrapper>
      ) : null}
      {props.price?.regular && props.price.regular > 0 ? (
        <PriceWrapper>
          <div>
            <BodySmallText emphasis={FontEmphasis.LOW}>
              {t('product', 'price.from-abbr')}
            </BodySmallText>{' '}
            <Price
              price={props.price.regular}
              isDeal={!!props.diffPercentage}
            />
          </div>
          {props.diffPercentage ? (
            <DealBadge
              color="RED_INVERTED"
              size={BadgeSize.SMALL}
              text={`-${Math.round(props.diffPercentage)}%`}
            />
          ) : undefined}
        </PriceWrapper>
      ) : null}
    </MiniCard>
  );
};
